import { IFontData } from '@picsart/rc/types/data/fontsData';
import { MAX_RECENT_FONTS } from 'constants/textTool';
import { createActionCreator, createReducer } from 'deox';
import { AppState } from 'types/AppState';

export type PersistedSettings = { recentFonts: IFontData[] };

const defaultState: PersistedSettings = {
  recentFonts: []
};

export const addRecentFont = createActionCreator(
  'PERSISTED_SETTINGS/ADD_RECENT_FONT',
  resolve => (font: IFontData) => resolve(font)
);

export const persistedSettings = createReducer(defaultState, handle => [
  handle(addRecentFont, (state, { payload }) => {
    let list = [...state.recentFonts];

    const duplicateIndex = state.recentFonts.findIndex(
      item => item.font_family === payload.font_family
    );
    list.splice(duplicateIndex, 1);

    list = [payload, ...list];

    return {
      ...state,
      recentFonts: list.splice(0, MAX_RECENT_FONTS)
    };
  })
]);

export const getRecentFonts = (state: AppState): IFontData[] => state.persistedSettings.recentFonts;
